// AUTH

export const AUTH_SIGNIN_REQUEST = 'AUTH_SIGNIN_REQUEST';
export const AUTH_SIGNIN_SUCCESS = 'AUTH_SIGNIN_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_SIGNOUT_REQUEST = 'AUTH_SIGNOUT_REQUEST';
export const AUTH_SIGNOUT_SUCCESS = 'AUTH_SIGNOUT_SUCCESS';
export const AUTH_UPDATE_PASSWORD_REQUEST = 'AUTH_UPDATE_PASSWORD_REQUEST';
export const AUTH_UPDATE_PASSWORD_SUCCESS = 'AUTH_UPDATE_PASSWORD_SUCCESS';
export const AUTH_USER_MIGRATED = 'AUTH_USER_MIGRATED';




// WEBPACK FOOTER //
// ./src/actions/types/index.js